<template>
  <fragment>
    <div class="body-wrapper-inner">
      <div class="container-fluid">
        <div class="card">
          <div class="card-body">

            <div class="d-sm-flex gap-1 align-items-center mb-4">
              <h5 class="card-title fw-semibold mb-3 mb-sm-0 me-auto">User Administrator</h5>
              <form @submit.prevent="getDataList" class="d-flex gap-1">
                <div class="input-group">
                  <input
                    v-model="cariTitle"
                    type="text"
                    class="form-control bg-light"
                    placeholder="Pencarian..."
                    autocomplete="off"
                  >
                  <button class="btn btn-primary">Cari</button>
                </div>
              </form>
            </div>
            <hr class="border-0 bg-primary pt-1 rounded my-4">

            <div class="table-responsive">
              <table class="table align-middle table-striped table-hover">
                <thead>
                  <tr>
                    <th scope="col">#</th>
                    <th class="w-50 text-nowrap" scope="col">
                      <a href="#" class="link-dark">
                        Nama Lengkap
                        <i class="ti ti-caret-up-down-filled"></i>
                      </a>
                    </th>
                    <th class="text-nowrap" scope="col">Alamat Email</th>
                    <th class="text-center text-nowrap" scope="col">No. Telpon</th>
                    <th class="text-center text-nowrap" scope="col">
                      <a href="#" class="link-dark">
                        Tipe Akun
                        <i class="ti ti-caret-up-down-filled"></i>
                      </a>
                    </th>
                    <th class="text-center text-nowrap" scope="col">
                      <a href="#" class="link-dark">
                        Status
                        <i class="ti ti-caret-up-down-filled"></i>
                      </a>
                    </th>
                    <th class="text-end" scope="col"></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(req, idx) in dataList" :key="req.id">
                    <td scope="row">{{ idx + 1 }}</td>
                    <td class="text-nowrap">{{ safeGet(req, 'user_profile.fullname') }}</td>
                    <td>
                      <a
                        class="link-primary"
                        :href="`mailto:${req.email}`"
                        target="_blank"
                        :title="`Send mail to ${req.email}`"
                      >{{ req.email }}</a>
                    </td>
                    <td class="text-center">{{ safeGet(req, 'user_profile.telp') }}</td>

                    <td class="text-center">
                      <small
                        :class="req.type == 'doctor' ? 'text-bg-primary' : 'text-bg-secondary'"
                        class="badge fs-1 bg-opacity-75"
                      >{{ req.type }}</small>
                    </td>
                    <td class="text-center">
                      <template v-if="req && req.site_status">
                        <small
                          :class="req.statusId == 1 ? 'text-bg-success' : 'text-bg-danger'"
                          class="badge fs-1 bg-opacity-75"
                        >{{ req.site_status.status_name }}</small>
                      </template>
                    </td>

                    <td class="text-nowrap text-end">
                      <router-link
                        :to="`form-user?type=admin&userId=${req.id}`"
                        class="btn btn-sm btn-outline-primary me-1"
                        title="Ubah"
                      >
                        <i class="ti ti-edit fs-3"></i>
                      </router-link>
                      <a
                        href="#"
                        class="btn btn-sm btn-outline-danger"
                        title="Hapus"
                        @click="deleteData(req.id)"
                      >
                        <i class="ti ti-trash fs-3"></i>
                      </a>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <b-pagination
              class="justify-content-center"
              v-model="page"
              :total-rows="countDataList"
              :per-page="pageSize"
              prev-text="Previous"
              next-text="Next"
              @change="handlePageChange"
              size="md"
            ></b-pagination>
          </div>
        </div>
      </div>
    </div>
  </fragment>
</template>

<script>
import { mapGetters } from 'vuex'
import Highlight from '../components/Highlight.vue'
import EmptyPlaceholder from '../components/EmptyPlaceholder.vue'
import { allMixin } from '@/mixins/allMixin.js'

export default {
	mixins: [allMixin],
	components: {
		Highlight,
		EmptyPlaceholder
	},
	data() {
		return {
			token: localStorage.getItem('token'),
			order: 'desc',
			page: 1,
			pageSize: 30,
			pageSizes: [10, 20, 50],
			form: {
				id: '',
				fullname: '',
				type: '',
				email: '',
				password: '',
				birth_date: '',
				telp: '',
				roleId: '',
				statusId: '',
				nik: '',
				place_date: '',
				address: '',
				city: '',
				province: '',
				country: '',
				religion: '',
				specialization: '',
				licence_number: ''
			},
			cariTitle: '',
			formTitle: 'Add New',
			url: 'users/add',
			method: 'post'
		}
	},
	created() {
		if (!this.token) {
			this.$router.push('/login')
		}
		this.getDataList()
		// this.$store.commit("settings/setMenuActive", "dc-location");
		// this.$store.dispatch("auth/getNotif");
	},
	computed: {
		...mapGetters({
			dataList: 'location/getDCLocation',
			countDataList: 'location/getCountDCLocation'
		})
	},
	methods: {
		getDataList(reset_pagination, from = 'all') {
			if (reset_pagination) {
				this.page = 1
			}
			this.$store
				.dispatch('location/getData', {
					url: `users`,
					params: {
						fullname: this.cariTitle,
						type: 'doctor,nurse,admin',
						offset: this.page - 1,
						limit: this.pageSize,
						order: this.order
					}
				})
				.then(() => {
					console.log('doneeeeeeeeeee')
				})
		},
		handlePageChange(value) {
			this.page = value
			this.getDataList()
		},
		handlePageSizeChange(event) {
			this.pageSize = parseInt(event.target.value)
			this.page = 1
			this.getDataList()
		},
		onSubmit() {
			this.$store
				.dispatch('location/createNewRecord', {
					data: this.form,
					url: this.url,
					method: this.method
				})
				.then((res) => {
					console.log(res)
					let toast = this.$toasted.show(`${res.msg}`, {
						theme: 'bubble',
						position: 'top-right',
						duration: 3000
					})
					if (res.statusCode == 200) {
						this.getDataList()
						var myModalEl = document.getElementById('exampleModal')
						var modal = bootstrap.Modal.getInstance(myModalEl)
						modal.hide()
						this.form = {
							id: '',
							fullname: '',
							type: '',
							email: '',
							password: '',
							birth_date: '',
							telp: '',
							roleId: '',
							statusId: '',
							nik: '',
							place_date: '',
							address: '',
							city: '',
							province: '',
							country: '',
							religion: '',
							specialization: '',
							licence_number: ''
						}
					} else {
					}
				})
		},
		deleteData(id) {
			var conf = confirm('Kamu akan menghapus rekaman ini. Apa kamu yakin?')
			if (conf === false) {
				return
			}
			this.$store
				.dispatch('location/createNewRecord', {
					url: 'users/' + id,
					method: 'DELETE'
				})
				.then((res) => {
					console.log(res)
					let toast = this.$toasted.show(`${res.msg}`, {
						theme: 'bubble',
						position: 'top-right',
						duration: 3000
					})
					if (res.statusCode == 200) {
						this.getDataList()
					} else {
					}
				})
		},
		edit(id) {
			let data = this.dataList.find((o) => o.id === id)
			console.log(data)
			this.form = {
				id: id,
				fullname: data.user_profile.fullname,
				type: data.type,
				email: data.email,
				password: '',
				birth_date: data.user_profile.birth_date,
				telp: data.user_profile.telp,
				roleId: data.roleId,
				statusId: data.statusId,
				nik: data.user_profile.nik,
				place_date: data.user_profile.place_date,
				address: data.user_profile.address,
				city: data.user_profile.city,
				province: data.user_profile.province,
				country: data.user_profile.country,
				religion: data.user_profile.religion,
				specialization: data.user_profile.specialization,
				licence_number: data.user_profile.licence_number
			}

			this.formTitle = 'Edit'
			this.url = 'users/update/' + id
			this.method = 'put'
		},
		add() {
			this.form = {
				id: '',
				fullname: '',
				type: '',
				email: '',
				password: '',
				birth_date: '',
				telp: '',
				roleId: '',
				statusId: '',
				nik: '',
				place_date: '',
				address: '',
				city: '',
				province: '',
				country: '',
				religion: '',
				specialization: '',
				licence_number: ''
			}
			this.formTitle = 'Add New'
			this.url = 'users/add'
			this.method = 'post'
		}
	}
}
</script>

<style lang="scss">
.file {
	position: relative;
	overflow: hidden;
}

.input-file {
	position: absolute;
	font-size: 50px;
	opacity: 0;
	right: 0;
	top: 0;
}
</style>
